import Vue from 'vue';
import VueForceNextTick from 'vue-force-next-tick';

Vue.use(VueForceNextTick);
